module.exports = __webpack_public_path__ + "static/media/3DPPA8.a2dba2f3.jpg";